// extracted by mini-css-extract-plugin
module.exports = {"generateReportFab":"style_generateReportFab__3B_YZ","fabLoader":"style_fabLoader__31h69"};